export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 border border-background-200 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
              移动观影
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              无需下载APP，手机浏览器打开7777影院即可享受与APP一致的高清观影体验。
              支持PWA安装，一键添加到手机桌面，随时随地追剧观影。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center text-primary-600">
                  <i className="ri-android-line"></i>
                </div>
                <span className="text-sm text-foreground-700">Android 适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center text-primary-600">
                  <i className="ri-apple-line"></i>
                </div>
                <span className="text-sm text-foreground-700">iOS 适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-5 h-5 flex items-center justify-center text-primary-600">
                  <i className="ri-tablet-line"></i>
                </div>
                <span className="text-sm text-foreground-700">平板适配</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-400/10 to-accent-400/10 rounded-3xl blur-xl"></div>
              <div className="relative w-[200px] h-[400px] bg-background-200 rounded-3xl overflow-hidden shadow-lg border-4 border-background-300">
                <div className="h-full flex flex-col">
                  <div className="h-8 bg-background-300"></div>
                  <div className="flex-1 p-3 space-y-2">
                    <div className="h-24 bg-background-200 rounded-lg"></div>
                    <div className="h-24 bg-background-200 rounded-lg"></div>
                    <div className="h-24 bg-background-200 rounded-lg"></div>
                    <div className="h-6 w-3/4 bg-primary-100 rounded"></div>
                    <div className="h-2 w-full bg-background-200 rounded"></div>
                    <div className="h-2 w-5/6 bg-background-200 rounded"></div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-3 -right-3 w-16 h-16 bg-primary-500/15 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}